import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { Network } from "../../core/model/network";
import { Country } from "../../core/model/country";
import { CountryService } from "../../core/service/country.service";
import { NetworkService } from "../../core/service/network.service";

@Component({
  selector: "app-add-network",
  templateUrl: "./add-network.component.html",
  styleUrls: ["./add-network.component.scss"],
})
export class AddNetworkComponent implements OnInit {
  network: Network = new Network();
  countries: Country[];

  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _countryService: CountryService,
    private _networkService: NetworkService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      label: [null, Validators.compose([Validators.required])],
      country: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getCountries();
  }

  getCountries() {
    this._countryService.getAllCountries().subscribe(
      (data) => {
        this.countries = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save(): void {
    this.pressButton = true;

    this._networkService
      .postNetwork(this.network)
      .pipe(first())
      .subscribe(
        (data) => {
          this.pressButton = false;
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
